import React, { useState } from "react";
import { Modal, Input, Select } from "antd";

interface AddCardMerchantProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  loading?: boolean;
}

const { Option } = Select;

const AddCardMerchant: React.FC<AddCardMerchantProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
}) => {
  const [name, setName] = useState("");
  const [environment, setEnvironment] = useState<
    "sandbox" | "live" | ""
  >("");

  const handleSubmit = () => {
    if (!name || !environment) return;

    onSubmit({ name, environment });

    setName("");
    setEnvironment("");
  };

  return (
    <Modal
      title="Add New Merchant"
      open={open}
      onCancel={onClose}
      footer={null}
    >
      <div className="flex flex-col gap-4">
        {/* Name */}
        <Input
          size="large"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter Merchant Name"
        />

        {/* Environment */}
        <Select
          size="large"
          value={environment || undefined}
          onChange={(value) => setEnvironment(value)}
          placeholder="Select Environment"
          className="w-full"
        >
          <Option value="sandbox">Sandbox</Option>
          <Option value="live">Live</Option>
        </Select>

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`w-full py-2 rounded-md text-white ${
            loading ? "bg-gray-400" : "bg-primary"
          }`}
        >
          Add Merchant
        </button>
      </div>
    </Modal>
  );
};

export default AddCardMerchant;